import { FieldTypes } from '../constants/FieldTypes'
import {
  CheckboxField,
  DropdownField,
  DropdownOption,
  Field,
  FieldCondition,
  FieldMap,
  FormElement,
  InputFormElement,
  TextAreaField,
} from '../types'
import { isField, isFieldMap, isInfoStage } from '../utils/fields'

export const makeOptional = (field: Field): Field => ({
  ...field,
  optional: true,
})

// recursively find fields by type, returns array of objects with path and field
export const findFieldsByType = (fields: FieldMap, type: FieldTypes) => {
  const result: { path: string; field: Field }[] = []
  Object.entries(fields.children).forEach(([path, field]) => {
    if (isInfoStage(field)) return
    if (isField(field) && field.type === type) {
      result.push({ path, field })
    } else if (isFieldMap(field)) {
      result.push(...findFieldsByType(field, type))
    }
  })
  return result
}

export const replaceFields = (
  fields: FieldMap,
  // replaced: Record<string, F['children'][string]>,
  replaced: Record<string, FormElement>,
): FieldMap => {
  const newFields = { ...fields }
  Object.entries(replaced).forEach(([path, field]) => {
    newFields.children[path] = field
  })

  return newFields
}

export const replaceField = (fields: FieldMap, path: string, field: FormElement): FieldMap =>
  replaceFields(fields, { [path]: field })

export const createTextAreaField = (placeholder: string, optional?: boolean): TextAreaField => ({
  placeholder,
  type: FieldTypes.TEXTAREA,
  optional,
})

export const addCondition = <T extends InputFormElement>(
  { condition: existingCondition, ...field }: T,
  condition: FieldCondition,
): T =>
  ({
    ...field,
    condition: existingCondition ? v => existingCondition(v) && condition(v) : condition,
  }) as T

export const createRadioField = (
  placeholder: string,
  options: DropdownOption<any>[],
): DropdownField => ({
  type: FieldTypes.DROPDOWN,
  placeholder,
  inputType: 'radio',
  options,
})

export const addFieldRow = (field: Field, row: { index: number; flex: number }): Field => ({
  ...field,
  row,
})

export const createCheckboxField = (placeholder: string): CheckboxField => ({
  type: FieldTypes.CHECKBOX,
  placeholder,
})
